import { Fragment } from 'react'
import { useRouter } from 'next/router'
import { GetStaticPropsContext, NextPage } from 'next'
import { useTranslation } from 'next-i18next'

import MediaMediabank from '~/static-pages/media/pages/media-mediabank/MediaMediabank.page'
import MediaPageWrapper from '~/static-pages/media/components/MediaPageWrapper/MediaPageWrapper'
import Metatags from '~/components/Metadata/Metatags'
import { DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'
import { DefaultLayout } from '~/shared/layouts/DefaultLayout'
import { NavigationElement } from '~/static-pages/media/components/MediaPageWrapper/MediaPageWrapperNav/MediaPageWrapperNav.types'
import { usePageTitle } from '~/utils/tags'

import { getMediabankAssetsList, getRunningQueriesThunk, useGetMediabankAssetsListQuery } from '~/redux/apis/media.api'
import { getStaticPropsWrapper } from '~/utils/pageWrapper/staticPageWrapper'
import { GetProps } from '~/utils/pageWrapper/types'

const MediaMediabankPage: NextPage = () => {
  const { t } = useTranslation('media')
  const title = usePageTitle(t('mediabankTitle'))
  const metaDescription = usePageTitle(t('mediaBankMetaDescription'))

  const { locale, isFallback } = useRouter()
  const { data = [] } = useGetMediabankAssetsListQuery({ language: locale as string }, { skip: isFallback })

  return (
    <Fragment>
      <Metatags metaDescription={metaDescription} noindex title={title} />

      <DefaultLayout>
        <MediaPageWrapper activeNavElement={NavigationElement.MEDIABANK}>
          <MediaMediabank assets={data} />
        </MediaPageWrapper>
      </DefaultLayout>
    </Fragment>
  )
}

export const getProps: GetProps =
  (store) =>
  async ({ locale }: GetStaticPropsContext) => {
    store.dispatch(
      getMediabankAssetsList.initiate({
        language: locale as string,
      }),
    )

    await Promise.all(store.dispatch(getRunningQueriesThunk()))

    const queries = store.getState().mediaApi.queries
    const query = Object.values(queries).find((q) => q?.endpointName === 'getMediabankAssetsList')
    const data = query ? (query.data as unknown[]) : []

    if (data.length === 0) {
      return {
        notFound: true,
      }
    }

    return {
      props: {
        namespaces: ['media', ...DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES],
      },
      revalidate: process.env.ENVIRONMENT === 'staging' ? 30 : false,
    }
  }

export const getStaticProps = getStaticPropsWrapper(getProps)
export default MediaMediabankPage
